var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tabs__item",class:{ active: _vm.tab.isActive },on:{"click":_vm.changeView}},[_vm._v(" "+_vm._s(_vm.tab.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }